import { isEmailInAllowlist } from "../../common/helpers/emailAllowlist.helpers";

export const RECEIVABLES_DASHBOARD_ALLOWED_EMAILS = [
  "wandson.helber@gmail.com",
  "pollyalvesdossantos@gmail.com",
  "rafaelpaulin@gmail.com",
  "manasses.arteman@gmail.com",
] as const;

export function canAccessReceivablesDashboard(
  email: string | undefined,
): boolean {
  return isEmailInAllowlist(email, RECEIVABLES_DASHBOARD_ALLOWED_EMAILS);
}
